<template>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <b-modal
        id="modal-stage"
        ok-title="修改"
        cancel-title="取消"
        cancel-variant="outline-secondary"
        size="sm"
        centered
        title="修改狀態"
        no-close-on-backdrop
        @ok.prevent="handleSubmit(onSubmit)"
      >
        <b-overlay
          :show="loading"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small
          rounded="sm"
        >
          <b-form class="mt-1" @submit.prevent="handleSubmit(onSubmit)">
            <b-form-group
              class=""
              label="狀態"
              label-for="project_stage_id"
            >
              <v-select
                v-model="projectData.project_stage_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="projectstageOptions"
                label="stage"
                :reduce="(option) => option.id"
                :clearable="true"
              >
                <template #option="{ stage, background_color }">
                  <div
                    class="rounded-circle d-inline-block mr-50 bg-primary"
                    :style="{
                      background: background_color + ' !important',
                      height: '10px',
                      width: '10px',
                    }"
                  />
                  <span> {{ stage }}</span>
                </template>
  
                <template #selected-option="{ stage, background_color }">
                  <div
                    class="rounded-circle d-inline-block mr-50 bg-primary"
                    :style="{
                      background: background_color + ' !important',
                      height: '10px',
                      width: '10px',
                    }"
                  />
                  <span> {{ stage }}</span>
                </template>
              </v-select>
            </b-form-group>
          </b-form>
        </b-overlay>
      </b-modal>
    </validation-observer>
  </template>
  
  <script>
  import {
    BModal,
    VBModal,
    BCardText,
    BOverlay,
    BForm,
    BFormGroup,
    BRow,
    BCol,
    BCardBody,
    BCard,
  } from "bootstrap-vue";
  
  import Ripple from "vue-ripple-directive";
  import { ref, onUnmounted } from "@vue/composition-api";
  import store from "@/store";
  import vSelect from "vue-select";
  import { ValidationProvider, ValidationObserver } from "vee-validate";
  import formValidation from "@core/comp-functions/forms/form-validation";

  export default {
    data() {
      return {};
    },
    components: {
      BModal,
      VBModal,
      BCardText,
      BOverlay,
      BForm,
      BFormGroup,
      BRow,
      BCol,
      BCardBody,
      BCard,
      vSelect,
      ValidationProvider,
      ValidationObserver,
    },
    directives: {
      "b-modal": VBModal,
      Ripple,
    },
    props: {
      projectData: {
        type: Object,
        required: true,
      },
      projectstageOptions: {
        type: Array,
        required: true,
      },
    },
    methods: {
      onSubmit() {
        this.$swal({
          title: "確認儲存?",
          showCancelButton: true,
          confirmButtonText: "儲存",
          cancelButtonText: '取消',
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            this.loading = true;
            store
              .dispatch("project/modifyProject", {id: this.projectData.id,project_stage_id: this.projectData.project_stage_id})
              .then((response) => {
                this.loading = false;
                this.$swal({
                  text: response.data.message,
                  icon: "success",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                  showClass: {
                    popup: "animate__animated animate__bounceIn",
                  },
                  buttonsStyling: false,
                });
                this.$emit("refetch-data");
                this.$emit("refetch-statistic");
                this.hide();
  
              })
              .catch((error) => {
                this.loading = false;
                this.$swal({
                  text: JSON.stringify(error.response.data.message),
                  icon: "error",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                  showClass: {
                    popup: "animate__animated animate__bounceIn",
                  },
                  buttonsStyling: false,
                });
              });
          }
        });
      },
      hide() {
        this.$bvModal.hide('modal-stage')
      },
    },
    setup(props, { emit }) {     
      const loading = ref(false);
      const resetprojectData = () => {
        props.projectData = JSON.parse(JSON.stringify({}));
      };
  
      const itemFormBlankItem = {
        id: 0,
        project_stage_id: null,
      };
  
      const { refFormObserver, getValidationState, resetForm } =
        formValidation(resetprojectData);
  
      return {
        loading,
        refFormObserver,
        getValidationState,
        resetForm,
        itemFormBlankItem,
      };
    },
  };
  </script>
  
  <style lang="scss">
  @import "@core/scss/vue/libs/vue-select.scss";
  </style>
  